import React, { FC, useState } from 'react';
import { CopyBlueRectangleIcon, CustomerIcon, MapIcon, PhoneIcon } from 'assets/icons';
import ChevronArrowRightReactIcon from 'assets/react-icons/ChevronArrowRightReactIcon';
import { JobCustomer } from '../jobs.model';
import { getAddressAsString } from '../utils';
import { copyToClipBoard } from 'utils/commonUtils';
import { WebAppColors } from 'constants/colors';
import { EstimateCustomer } from 'containers/estimates/estimates.model';

interface CustomerSectionProps {
  customer: JobCustomer | EstimateCustomer;
  onCustomerClick: () => void;
}

const CustomerSection: FC<CustomerSectionProps> = ({ customer, onCustomerClick }) => {
  const [isAddressCopied, setIsAddressCopied] = useState(false);
  const [isPhoneCopied, setIsPhoneCopied] = useState(false);

  const onCopyAddress = () => {
    setIsAddressCopied(true);
    copyToClipBoard(getAddressAsString(customer.serviceAddress[0]));
    setTimeout(() => setIsAddressCopied(false), 1000);
  };

  const onCopyPhoneNumber = () => {
    if (!customer.phoneNumber) return;
    setIsPhoneCopied(true);
    copyToClipBoard(customer.phoneNumber);
    setTimeout(() => setIsPhoneCopied(false), 1000);
  };

  return (
    <div className="flex flex-col gap-y-3 rounded-md border border-borderGray px-3 py-4">
      <div className="flex items-center justify-between border-b border-secondaryBtn pb-4">
        <div className="flex items-center">
          <CustomerIcon className="mr-3 shrink-0" />
          <div className="text-sbase font-semibold text-primaryText">
            {`${customer?.name || customer?.lastName ? `${customer.name} ${customer.lastName}` : '-'}`}
          </div>
        </div>
        <ChevronArrowRightReactIcon
          id="job-detail-cutomer-more-info-icon"
          className="shrink-0 cursor-pointer"
          fill={WebAppColors.Gray_1}
          onClick={onCustomerClick}
        />
      </div>
      <div className="flex justify-between">
        <div className="flex items-center">
          <PhoneIcon className="path-fill-current path mr-3 h-4 w-4 shrink-0 text-gray-1" />
          <div className="text-sbase font-semibold text-primaryText">{customer.phoneNumber || '-'}</div>
        </div>
        <CopyBlueRectangleIcon
          id="job-detail-customer-phone-copy-icon"
          role="presentation"
          className={`ml-1 shrink-0 ${customer.phoneNumber ? 'cursor-pointer' : 'opacity-50'}
                    ${isPhoneCopied && 'rounded bg-secondary/60'}`}
          onClick={onCopyPhoneNumber}
        />
      </div>
      {customer.serviceAddress?.length > 0 && (
        <div className="flex flex-col gap-y-2">
          <div className="flex justify-between">
            <div className="flex items-start">
              <MapIcon className="path-fill-current path mr-3 h-4 w-4 shrink-0 text-gray-1" />
              <div className="text-sbase font-semibold text-primaryText">
                {getAddressAsString(customer.serviceAddress[0])}
              </div>
            </div>
            <CopyBlueRectangleIcon
              id="job-detail-customer-address-copy-icon"
              role="presentation"
              className={`ml-1 shrink-0 cursor-pointer 
                     ${isAddressCopied && 'rounded bg-secondary/60'}`}
              onClick={onCopyAddress}
            />
          </div>
          {customer.serviceAddress[0].addressNote && (
            <div className="mr-1 pl-7 text-sbase font-semibold text-accentText">
              {customer.serviceAddress[0].addressNote}
            </div>
          )}
        </div>
      )}
    </div>
  );
};
export default CustomerSection;
